import React from "react";
import { Box, Card, Flex } from "rebass";
import { Page } from "react-pdf";

interface IProps {
  index: number;
  isVisible: boolean;
  height: string;
}

export const ListItem: React.FC<IProps> = ({ index, isVisible, height}) => (
  <Box
    width={1}
    css="& + & { padding-top: 15px; }"
  >
    <Card
      width={1}
      pt={height}
      borderBottom="1px solid"
      borderBottomColor="sp-gray"
      css="position: relative; overflow: hidden;"
    >
      <Flex
        justifyContent="center"
        alignItems="center"
        css="position: absolute; top: 0; left: 0; bottom: 0; right: 0;"
      >
        {isVisible && <Page pageIndex={index} />}
      </Flex>
    </Card>
  </Box>
);
